enum TableType {
    PRIMARY,
    SECONDARY,
    DEFAULT
}

export default TableType;